import { DateStep, EntityType, Locale } from '@frontend/common';
import { ErrorHandler } from '@frontend/error-handler';
import { useLocale } from '@frontend/lang';
import { useModals } from '@frontend/modal';
import { JobClient } from '@frontend/report/api';
import { Report } from '@frontend/report/types';
import { useAccountRepository } from '@frontend/repository';
import { ToastUtil } from '@frontend/toast-utils';
import { IUser } from '@frontend/user/types';
import { Dispatch, SetStateAction, useState } from 'react';
import { useIntl } from 'react-intl';

import { useAppDispatch, useAppSelector } from '../../redux/store';

export interface ViewProps {
    onClick: (obj: Report) => void;
    currentAccount: string;
    period: DateStep | null;
    setPeriod: (step: DateStep) => void;
    intl: ReturnType<typeof useIntl>;
    currentUser: IUser | null;
    setFromDate: Dispatch<SetStateAction<string | null>>;
    setToDate: Dispatch<SetStateAction<string | null>>;
    openModal: ReturnType<typeof useModals>['openModal'];
    scheduleModalId: string;
    dispatch: ReturnType<typeof useAppDispatch>;
    locale: Locale | undefined;
}

const useReportModalDetail = (): ViewProps => {
    const intl = useIntl();
    const { locale } = useLocale();
    const { currentAccount } = useAccountRepository();
    const userStore = useAppSelector((state) => state.users);
    const currentUser = userStore.current;
    const { openModal } = useModals();
    const dispatch = useAppDispatch();
    const scheduleModalId = 'report-schedule-modal';
    const [period, setPeriod] = useState<DateStep | null>(null);
    const [fromDate, setFromDate] = useState<string | null>(null);
    const [toDate, setToDate] = useState<string | null>(null);
    const onClick = (obj: Report) => {
        JobClient.postJob(currentAccount, obj.id, { period: period ?? obj.period, period_from_timestamp: fromDate, period_to_timestamp: toDate })
            .then((res) => {
                ToastUtil.success(intl.formatMessage({ id: 'report.modal.detail.generation-started', defaultMessage: 'Report generation started' }));
            })
            .catch((err) => ErrorHandler.handleError({ error: err, entity_type: EntityType.JOB }));
    };

    return {
        onClick,
        currentAccount,
        period,
        setPeriod,
        intl,
        currentUser,
        setFromDate,
        setToDate,
        openModal,
        scheduleModalId,
        dispatch,
        locale
    };
};

export default useReportModalDetail;
